import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'

/**
 * returns whether the corresponding button should be visible and enabled
 * based on the capabilities, feature flag, and the current state
 * - button `visible` if one of the `capabilities` is enabled and the FF is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfDNDButtonState = () => {
  // FIXME: get the current state from the store once DND is implemented
  const dndActive = false
  const selfDNDCapabilityOff = useCapabilitiesStore(
    state => state.selfDNDCapabilityOff,
  )
  const selfDNDCapabilityOn = useCapabilitiesStore(
    state => state.selfDNDCapabilityOn,
  )
  const isFeatureDisabled = useFeaturesStore(
    state =>
      state.disabled.ROOM_DO_NOT_DISTURB === FEATURES.ROOM_DO_NOT_DISTURB,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isDNDButtonVisible =
    !isFeatureDisabled && (selfDNDCapabilityOn || selfDNDCapabilityOff)

  const canEnterDND = !dndActive && selfDNDCapabilityOn
  const canExitDND = dndActive && selfDNDCapabilityOff

  // check if button can perform the necessary next action
  const isDNDButtonEnabled = canEnterDND || canExitDND

  return { isDNDButtonEnabled, isDNDButtonVisible }
}
